import DayJsUtils from "@date-io/dayjs";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import AlertProvider from "components/common/Alert";
import Loading from "components/common/Loading";
import nationalities from "i18n-nationality";
import { envInstants } from "libs/configs/env";
import theme from "libs/configs/theme";
import AdminModalLoadingProvider from "libs/context/AdminModalLoadingContext";
import ModalLoadingProvider from "libs/context/ModalLoadingContext";
import httpClientInstants from "libs/utils/HttpClient";
import { Suspense, useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "redux/store";
import Router from "Router";

nationalities.registerLocale(require("i18n-nationality/langs/en.json"));

function App() {
  const [isInitEnvError, setInitEnvError] = useState(false);
  const [isInitEnv, setInitEnv] = useState(false);

  useEffect(() => {
    const loadEnv = async () => {
      try {
        await envInstants.init();
        httpClientInstants.setBaseUrl(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
      }
    };

    loadEnv();
  }, []);

  if (!isInitEnv) return "";
  if (isInitEnvError) return "Cannot load env !!!";

  return (
    <Suspense fallback="">
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DayJsUtils}>
              <AdminModalLoadingProvider>
                <ModalLoadingProvider>
                  <AlertProvider>
                    <Router />
                    <CookieConsent
                      location="bottom"
                      buttonText="ACCEPT"
                      cookieName="BoiCookie"
                      style={{
                        background: "#255B99",
                        marginTop: 10,
                        justifyContent: "center",
                      }}
                      buttonStyle={{
                        background: "#0F94D7",
                        color: "#ffffff",
                        borderRadius: 5,
                      }}
                      declineButtonStyle={{
                        background: "#ffffff",
                        color: "#0F94D7",
                        borderRadius: 5,
                      }}
                      expires={150}
                      enableDeclineButton
                      declineButtonText="NOT NOW"
                      contentStyle={{ textAlign: "center" }}
                    >
                      We use cookies to enhance your user experience. To see
                      which cookies we use please see our &nbsp;
                      <a
                        style={{ color: "#0F94D7" }}
                        href="/cookie-policy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Cookie Statement
                      </a>
                    </CookieConsent>
                  </AlertProvider>
                </ModalLoadingProvider>
              </AdminModalLoadingProvider>
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </Suspense>
  );
}

export default App;
